// extracted by mini-css-extract-plugin
module.exports = {"numberTag":"NumberTag_numberTag__2-7-R","sizeDefault":"NumberTag_sizeDefault__2lT2n","sizeSmall":"NumberTag_sizeSmall__1VAdt","sizeLarge":"NumberTag_sizeLarge__37D5A"};